module.exports = __webpack_public_path__ + "static/img/paypal.4edbc7b9.jpeg";